export const SET_SEARCH = 'setSearch';